import styled from 'styled-components';

import Flex from '@decisiv/ui-components/lib/components/Flex';

export const CenteredContainer = styled(Flex)`
  width: 100%;
`;
